import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@saesa/ui-kit-front';

const MapsStyles = makeStyles(() =>
  createStyles({
    buscadorStack: {
      position: 'relative',
      top: '112px',
      left: '48px',
      width: '414px',
      zIndex: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 24,
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 'auto',
        bottom: '16px',
        left: '16px',
        right: '16px',
        width: 'auto',
        gap: 16,
      },
    },
    /**
     * Con el aviso PEC visible, la tarjeta de búsqueda cede alto para que el disclaimer quede en pantalla.
     */
    buscadorStackConDisclaimer: {
      maxHeight: 'calc(100vh - 152px)',
      '& $buscadorCnt': {
        maxHeight: 'none',
        flex: '1 1 auto',
        minHeight: 0,
      },
      /**
       * En mobile el aviso va debajo de la tarjeta, sin recortarle el título.
       * El alto lo publica DisclaimerPec en --alto-disclaimer-pec.
       */
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'none',
        gap: 12,
        '& $buscadorCnt': {
          maxHeight: 'calc(100vh - 120px - var(--alto-disclaimer-pec, 80px))',
          flex: '0 1 auto',
        },
      },
    },
    buscadorCnt: {
      width: '100%',
      padding: '24px 0 0',
      background: 'white',
      boxShadow: '0px 2px 30px rgba(9, 39, 84, 0.14)',
      borderRadius: '20px',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      overflow: 'hidden',
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 152px)',
      [theme.breakpoints.down('sm')]: {
        borderRadius: '20px',
        maxHeight: '55vh',
        boxShadow: '0px 2px 30px rgba(9, 39, 84, 0.14)',
      },
    },
    /**
     * Scrim sobre el mapa al abrir modal de corte (desktop y mobile).
     * Negro 10%; zIndex bajo el panel del modal (7/8) y sobre el mapa.
     */
    overlayMapaModal: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      zIndex: 6,
      pointerEvents: 'none',
    },
    buscadorHeader: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '0 32px',
      marginBottom: '20px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px',
        marginBottom: '16px',
      },
    },
    buscadorTitulo: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 700,
      fontSize: '21px',
      lineHeight: '28px',
      color: '#074177',
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    buscadorSubtitulo: {
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#5A607F',
      margin: 0,
    },
    buscadorBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      padding: '0 32px 24px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px 24px',
      },
    },
    botonBuscar: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '162px',
      height: '45px',
      borderRadius: '26px',
      textTransform: 'none',
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      boxShadow: 'none',
      backgroundColor: '#4F1FFF',
      color: 'var(--blanco)',
      '&:hover': {
        backgroundColor: 'var(--hover-primary)',
        boxShadow: 'none',
      },
      '&:disabled': {
        backgroundColor: '#EAEBF0',
        color: '#9196B1',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    inputCnt: {
      position: 'relative',
      width: '100%',
    },
    formCnt: {
      position: 'relative',
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    inputNroServicio: {
      width: '100%',
      color: 'var(--gris-l43)',
    },
    inputDireccion: {
      width: '100%',
      color: 'var(--gris-l43)',
    },
    lupaIcon: {
      '--icon-primary-dark': 'var(--gris-l43)',
    },
    btnIconDireccion: {
      position: 'absolute',
      right: '1.275rem',
      display: 'none',
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
    },
    flechaIcon: {
      '--icon-primary-dark': 'var(--primario-morado)',
    },
    flechaIconDisabled: {
      opacity: 0.5,
    },
    inputHasError: {},
    esconderElemento: {
      display: 'none',
    },
    textoCambiar: {
      fontSize: '.875rem',
      color: 'var(--primario-morado)',
      textAlign: 'center',
    },
    modal: {
      zIndex: 1,
    },
    principal: {
      display: 'flex',
      position: 'relative',
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
    circulo: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'start',
      alignItems: 'center',
      width: '2.75rem',
      height: '2.75rem',
      borderRadius: '50%',
      margin: '2.5rem 9.375rem 0 0',
      '&:first-child': {
        marginLeft: '0',
        marginRight: '9.375rem',
        '&::before': {
          width: '2.5rem',
          transform: 'translateY(-2.625rem) rotate(90deg)',
        },
      },
      '&::before': {
        display: 'block',
        position: 'absolute',
        content: '""',
        height: '.25rem',
        width: '2.5rem',
        transform: 'translateY(-2.625rem) rotate(90deg)',
      },
      '&:last-child': {
        margin: '2.5rem 9.375rem 2.5rem 0',
      },
    },
    textos: {
      position: 'absolute',
      top: '-40px',
      width: 'max-content',
      transform: 'translate(65px, 45px)',
      textAlign: 'start',
    },
    iconoCnt: {
      display: 'flex',
      padding: '1rem 0',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    icono: {
      transform: 'translateX(10px)',
    },
    disclaimerQuinceMinutos: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '8px 20px',
      gap: '10px',
      background: '#F7F5FF',
      borderRadius: '0',
      margin: 0,
      width: '100%',
    },
    textoDisclaimerQuinceMinutos: {
      display: 'flex',
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      textAlign: 'center',
      color: '#5A607F',
      justifyContent: 'center',
    },
    contenedorBuscadorDireccion: {
      width: '100%',
    },
    toggleButtonContainer: {
      display: 'flex',
      width: '100%',
      gap: '12px',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
    },
    toggleButton: {
      padding: '8px 20px 6px',
      display: 'flex',
      background: 'transparent',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      border: '2px solid #DBE4ED',
      borderRadius: '16px',
      cursor: 'pointer',
      color: '#5A607F',
      transition: '.5s ease all',
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontSize: '14px',
      fontWeight: 400,
      height: '32px',
    },
    toggleButtonActive: {
      background: '#DBE4ED',
      color: '#060709',
      fontWeight: 600,
      border: '2px solid #DBE4ED',
    },
    labelRoot: {
      transform: ' translate(14px, 14px) scale(1)',
      fontWeight: 400,
      fontSize: '14px',
      color: 'var(--gris-l63)',
      fontStyle: 'regular',
    },
    inputRoot: {
      display: 'flex',
      alignItems: 'center',
      height: '45px',
      [theme.breakpoints.down('sm')]: {
        paddingRight: '4px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#9196B1',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#9196B1',
      },
    },
    inputPropDireccion: {
      paddingLeft: '4px',
      fontSize: '14px',
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      lineHeight: '18px',
      '&::placeholder': {
        color: 'var(--gris-l63)',
        opacity: 0.9,
      },
    },
    inputPropNroServicio: {
      paddingLeft: '14px',
      fontSize: '14px',
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      lineHeight: '18px',
      '&::placeholder': {
        color: 'var(--gris-l63)',
        opacity: 0.9,
      },
    },
  })
);

export default MapsStyles;
